export default {"src":"/_next/static/media/Logo.7b708f7f.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};